import React from 'react'
import { platform } from '../constants'
import DesktopContent from './DesktopContent'
import MobileContent from './MobileContent'

interface InstruccionesImageProps {
  browser: string
  os: string
  brand: string
  token: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  password: string
}

const InstruccionesImage: React.FC<InstruccionesImageProps> = ({
  browser,
  os,
  brand,
  token,
  language,
  startDate,
  endDate,
  meetingNumber,
  password,
}) => {
  return (
    <div className="space-y-6 text-base mb-16 text-generic-neutral-900 font-aeonik">
      {platform === 'mobile' ? (
        <MobileContent
          browser={browser}
          os={os}
          brand={brand}
          token={token}
          language={language}
          startDate={startDate}
          endDate={endDate}
          meetingNumber={meetingNumber}
          password={password}
        />
      ) : (
        <DesktopContent
          browser={browser}
          os={os}
          brand={brand}
          token={token}
          language={language}
          startDate={startDate}
          endDate={endDate}
          meetingNumber={meetingNumber}
          password={password}
        />
      )}
    </div>
  )
}

export default InstruccionesImage
